import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  tableHead: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '8fr 24fr 1fr',
    color: theme.palette.text.secondary,
    alignItems: 'center',
    padding: '0 0 0 12px',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,
    borderRadius: 12
  },
  tableHeadMobile: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    color: theme.palette.text.secondary,
    padding: '8px 0 8px 0',
    marginBottom: 4,
    marginTop: 4,
    backgroundColor: theme.palette.background.paper,

    borderRadius: 12,
    alignItems: 'center',
    textAlign: 'center'
  },
  tableHeadCellMobile: {
    textAlign: 'left',
    paddingLeft: 12,
    flex: 1
  },
  tableRow: {
    display: 'grid',
    gridTemplateColumns: '8fr 24fr 1fr',
    height: 'auto',
    minHeight: 100,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    paddingLeft: 12,
    transition: 'background-color 0.3s ease-in-out',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  tableRowRoot: {
    display: 'grid',
    gridTemplateColumns: '22fr 1fr',
    height: 'auto',
    minHeight: 100,
    marginBottom: 4,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    borderRadius: 20,
    cursor: 'pointer',
    paddingLeft: 12,
    transition: 'background-color 0.3s ease-in-out',
    width: '100%',
    textAlign: 'unset',
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  tableRowMobile: {
    display: 'flex',
    height: 60,
    alignItems: 'center',
    backgroundColor: theme.palette.background.default,
    transition: 'background-color 0.3s ease-in-out',
    borderRadius: 20,
    cursor: 'default',
    textAlign: 'center',
    paddingLeft: 13,
    '&:hover': {
      backgroundColor: theme.palette.background.paper
    }
  },
  userLogo: {
    width: 60,
    height: 60,
    borderRadius: '50%',
    background: '#dfdfdf',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 12
  },
  nameCell: {
    textAlign: 'left',
    flex: 1
  },
  descriptionCell: {
    textAlign: 'left'
  },
  moreIcon: {
    cursor: 'pointer'
  },
  refreshButtonContainer: {
    margin: 'auto'
  },
  skeleton: {
    width: '80%'
  },
  userInfoContainerSkeleton: {
    width: '80%'
  },
  userInfoNameSkeleton: {
    width: '80%'
  }
}))

export default useStyles
